<template>
  <tr v-if="linkSetFilter.length">
    <th style="border-bottom: 0">
      <slot></slot>
    </th>
    <td style="border-bottom: 0">
      <div v-for="(linkset, index) in linkSetFilter" :key="index">
        <span>{{ getLinksetTitle(linkset.key) }}</span>
        <ul>
          <li v-for="(link, linkIndex) in linkset.data" :key="linkIndex">
            <a :href="link.href">{{ link.title }}</a>
            <span v-for="(lang, langIndex) in link.hreflang" :key="langIndex">
              <lang-string :lang="lang"></lang-string>
            </span>
          </li>
        </ul>
        <div style="margin-bottom: 5px"></div>
      </div>
    </td>
  </tr>
</template>

<script>
import { saveGet } from '@/mixins/saveGet'
import LangString from '@/components/LangString'

export default {
  name: 'LinksTr',
  props: ['linkSet'],
  components: {
    LangString
  },
  mixins: [saveGet],
  data() {
    return {
      linkTypes: [
        {
          title: 'Activity Ideas',
          value: 'https://www.gs1.org/voc/activityIdeas'
        },
        {
          title: 'Allergen Information',
          value: 'https://www.gs1.org/voc/allergenInfo'
        },
        {
          title: 'Careers Information',
          value: 'https://www.gs1.org/voc/careersInfo'
        },
        {
          title: 'Certification Information',
          value: 'https://www.gs1.org/voc/certificationInfo'
        },
        {
          title: 'Consumer Handling and Storage Information',
          value: 'https://www.gs1.org/voc/consumerHandlingStorageInfo'
        },
        {
          title: 'EPC Information Services (EPCIS) repository',
          value: 'https://www.gs1.org/voc/epcis'
        },
        {
          title: 'Events Information',
          value: 'https://www.gs1.org/voc/eventsInfo'
        },
        {
          title: 'Frequently Asked Questions',
          value: 'https://www.gs1.org/voc/faqs'
        },
        {
          title: 'Has Retailers',
          value: 'https://www.gs1.org/voc/hasRetailers'
        },
        {
          title: 'Homepage',
          value: 'https://www.gs1.org/voc/homepage'
        },
        {
          title: 'Ingredients Information',
          value: 'https://www.gs1.org/voc/ingredientsInfo'
        },
        {
          title: 'Instructions',
          value: 'https://www.gs1.org/voc/instructions'
        },
        {
          title: 'JSON Web Signature',
          value: 'https://www.gs1.org/voc/jws'
        },
        {
          title: 'Leave a Review',
          value: 'https://www.gs1.org/voc/leaveReview'
        },
        {
          title: 'Location Information',
          value: 'https://www.gs1.org/voc/locationInfo'
        },
        {
          title: 'Logistics Information',
          value: 'https://www.gs1.org/voc/logisticsInfo'
        },
        {
          title: 'Master Data',
          value: 'https://www.gs1.org/voc/masterData'
        },
        {
          title: 'Menu Information',
          value: 'https://www.gs1.org/voc/menuInfo'
        },
        {
          title: 'Nutritional Information',
          value: 'https://www.gs1.org/voc/nutritionalInfo'
        },
        {
          title: 'Opening Hours Information',
          value: 'https://www.gs1.org/voc/openingHoursInfo'
        },
        {
          title: 'Make Payment',
          value: 'https://www.gs1.org/voc/paymentLink'
        },
        {
          title: 'Product Information Page',
          value: 'https://www.gs1.org/voc/pip'
        },
        {
          title: 'Sustainability and Recycling (Deprecated)',
          value: 'https://www.gs1.org/voc/productSustainabilityInfo'
        },
        {
          title: 'Promotion',
          value: 'https://www.gs1.org/voc/promotion'
        },
        {
          title: 'Purchase Supplies or Accessories',
          value: 'https://www.gs1.org/voc/purchaseSuppliesOrAccessories'
        },
        {
          title: 'Quick Start Guide',
          value: 'https://www.gs1.org/voc/quickStartGuide'
        },
        {
          title: 'Recall Status',
          value: 'https://www.gs1.org/voc/recallStatus'
        },
        {
          title: 'Recipe Website',
          value: 'https://www.gs1.org/voc/recipeInfo'
        },
        {
          title: 'Register Purchase',
          value: 'https://www.gs1.org/voc/registerProduct'
        },
        {
          title: 'Entry in a Register',
          value: 'https://www.gs1.org/voc/registryEntry'
        },
        {
          title: 'Related Video',
          value: 'https://www.gs1.org/voc/relatedVideo'
        },
        {
          title: 'Reviews',
          value: 'https://www.gs1.org/voc/review'
        },
        {
          title: 'Safety Information',
          value: 'https://www.gs1.org/voc/safetyInfo'
        },
        {
          title: 'Scheduling/Reservation',
          value: 'https://www.gs1.org/voc/scheduleTime'
        },
        {
          title: 'Service Information',
          value: 'https://www.gs1.org/voc/serviceInfo'
        },
        {
          title: 'Smart Label',
          value: 'https://www.gs1.org/voc/smartLabel'
        },
        {
          title: 'Social Media',
          value: 'https://www.gs1.org/voc/socialMedia'
        },
        {
          title: 'Statistics',
          value: 'https://www.gs1.org/voc/statisticInfo'
        },
        {
          title: 'Support',
          value: 'https://www.gs1.org/voc/support'
        },
        {
          title: 'Sustainability and Recycling',
          value: 'https://www.gs1.org/voc/sustainabilityInfo'
        },
        {
          title: 'Traceability Information',
          value: 'https://www.gs1.org/voc/traceability'
        },
        {
          title: 'Tutorial',
          value: 'https://www.gs1.org/voc/tutorial'
        },
        {
          title: 'Sign waiver/agreement/document',
          value: 'https://www.gs1.org/voc/userAgreement'
        },
        {
          title: 'Verification Service',
          value: 'https://www.gs1.org/voc/verificationService'
        },
        {
          title: "What's in the box?",
          value: 'https://www.gs1.org/voc/whatsInTheBox'
        }
      ]
    }
  },
  computed: {
    linkSetFilter() {
      const result = []
      var linkSetArray = this.linkSet
      if (!Array.isArray(linkSetArray)) {
        // for glns this is an array, for gtins just one object... thx grp....
        linkSetArray = [linkSetArray]
      }
      for (const linkSet of linkSetArray) {
        for (const key in linkSet) {
          if (key.includes('gs1:') || key.includes('voc')) {
            const data = linkSet[key]
            if (Array.isArray(data)) {
              result.push({ key, data })
            }
          }
        }
      }
      console.debug('computed linkset', result, 'from', this.linkSet)
      return result
    }
  },
  methods: {
    getLinksetTitle(key) {
      const regex = /\/voc\/(.+)|gs1:(.+)/
      const match = key.match(regex)
      if (match) {
        const searchKey = match[1] || match[2]
        const linkType = this.linkTypes.find(item =>
          item.value.includes(searchKey)
        )
        return linkType ? linkType.title : key
      }
      return key
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LinksTr.vue